// extracted by mini-css-extract-plugin
module.exports = {"mobile":"rdg_ebf4eb65","desktop":"rdg_14e32b29","hasBorder":"rdg_68ad2cf5","accordionItem":"rdg_40a88c1e"};